// @ts-nocheck
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    LoadRealTimeInventory,
    SetupVariantSelection,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

function StoreGetVariantSelection(product?: ProductModel, variantChildren?: ProductModel[], styledOption?: string) {
    const variantSelection: SafeDictionary<string> = {};
    if (!product?.isVariantParent || !variantChildren) {
        return variantSelection;
    }

    if (styledOption || product.defaultChildProductId) {
        /* Store Custom Code - Start */
        const varaintChildByStyledOptions: ProductModel | undefined = styledOption
            ? variantChildren.find(o => o.productNumber.toLowerCase() === styledOption.toLowerCase())
            : undefined;

        const variantChild =
            varaintChildByStyledOptions || variantChildren.find(o => o.id === product.defaultChildProductId);
        /* Store Custom Code - End */

        variantChild?.childTraitValues?.forEach(o => {
            variantSelection[o.styleTraitId] = o.id;
        });

        if (Object.keys(variantSelection).length > 0) {
            return variantSelection;
        }
    }

    product.variantTraits?.forEach(variantTrait => {
        const defaultVariantValue = variantTrait.traitValues?.find(traitValue => traitValue.isDefault);
        variantSelection[variantTrait.id] = defaultVariantValue?.id ?? "";
    });

    return variantSelection;
}

replaceInChain(chain, SetupVariantSelection, props => {
    /* Store Custom Code - Start */
    props.variantSelection = StoreGetVariantSelection(
        props.product,
        props.variantChildren,
        props.parameter.styledOption,
    );
    /* Store Custom Code - End */
});

replaceInChain(chain, LoadRealTimeInventory, props => {
    if (
        !props.product ||
        (getIsWebCrawler() &&
            !getSettingsCollection(props.getState()).websiteSettings.includeRealTimeInventoryAndPricingForSeo)
    ) {
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds: [props.product.id, ...(props.variantChildren?.map(o => o.id) ?? [])],
            onComplete: realTimeInventoryProps => {
                const realTimeInventory = realTimeInventoryProps?.apiResult;

                if (realTimeInventoryProps?.error) {
                    if (props.product) {
                        props.dispatch({
                            type: "Pages/ProductDetails/FailedLoadRealTimeInventory",
                            productId: props.product.id,
                        });
                    }
                } else if (realTimeInventory) {
                    if (realTimeInventory.realTimeInventoryResults && props.variantChildren && props.product) {
                        const discontinued: SafeDictionary<boolean> = {};
                        for (const result of realTimeInventory.realTimeInventoryResults) {
                            if (!result.qtyOnHand) {
                                discontinued[result.productId] = true;
                            }
                        }
                        const initialCount = props.variantChildren.length;
                        props.variantChildren = props.variantChildren.filter(
                            o => !o.isDiscontinued || (o.isDiscontinued && !discontinued[o.id]),
                        );

                        if (initialCount !== props.variantChildren.length) {
                            const variantChildrenDataView = getVariantChildrenDataView(
                                props.getState(),
                                props.product.id,
                            );
                            const { value, ...otherProps } = variantChildrenDataView;
                            props.dispatch({
                                type: "Data/Products/ReplaceDataView",
                                parameter: {
                                    productId: props.product.id,
                                    variantChildren: true,
                                },
                                dataView: {
                                    value: props.variantChildren,
                                    ...otherProps,
                                },
                            });

                            const productInfo =
                                props.getState().pages.productDetails.productInfosById?.[props.product.id] ??
                                createFromProduct(
                                    getProductState(props.getState(), props.product.id).value ?? props.product,
                                );

                            props.dispatch({
                                type: "Pages/ProductDetails/UpdateVariantSelection",
                                /* Store Custom Code - Start */
                                variantSelection: StoreGetVariantSelection(
                                    props.product,
                                    props.variantChildren,
                                    props.parameter.styledOption,
                                ),
                                /* Store Custom Code - End */
                                variantSelectionCompleted: false,
                                selectedProductInfo: productInfo,
                            });
                        }
                    }

                    props.dispatch({
                        type: "Pages/ProductDetails/CompleteLoadRealTimeInventory",
                        realTimeInventory,
                    });
                }

                props.inventoryLoaded = true;
            },
        }),
    );
});
